var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('img',{attrs:{"src":_vm.src}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }